(function () {
  var fab = null;

  function openDrawer() {
    var drawer = document.querySelector('cart-drawer');
    if (drawer) {
      if (typeof drawer.open === 'function') {
        drawer.open();
      } else {
        drawer.classList.add('active');
        drawer.removeAttribute('hidden');
        document.body.classList.add('overflow-hidden');
      }
      return;
    }
    window.location.href = '/cart';
  }

  function createFab() {
    if (document.querySelector('.thered-cart-fab')) return document.querySelector('.thered-cart-fab');
    var btn = document.createElement('button');
    btn.type = 'button';
    btn.className = 'thered-cart-fab';
    btn.setAttribute('aria-label', 'View cart');
    btn.innerHTML =
      '<span class="thered-cart-fab__icon">' +
      '<svg width="20" height="22" viewBox="0 0 20 22" aria-hidden="true">' +
      '<path d="M14 7V5a4 4 0 00-8 0v2H2v13h16V7h-4zm-6-2a2 2 0 014 0v2H8V5z" fill="currentColor"/>' +
      '</svg></span>' +
      '<span class="thered-cart-fab__label">VIEW CART</span>' +
      '<span class="thered-cart-fab__count">0</span>';
    btn.addEventListener('click', openDrawer);
    document.body.appendChild(btn);
    return btn;
  }

  function update(opts) {
    opts = opts || {};
    fetch('/cart.js', { credentials: 'same-origin' })
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        if (!fab) fab = createFab();
        var count = cart.item_count || 0;
        var countEl = fab.querySelector('.thered-cart-fab__count');
        if (countEl) countEl.textContent = count;
        if (count > 0) {
          fab.classList.add('thered-cart-fab--visible');
          if (opts.pulse) {
            fab.classList.remove('thered-cart-fab--pulse');
            void fab.offsetWidth;
            fab.classList.add('thered-cart-fab--pulse');
          }
        } else {
          fab.classList.remove('thered-cart-fab--visible');
        }
      })
      .catch(function () {});
  }

  // Initial render of FAB (and persistent visibility if cart already has items across pages)
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { update({ pulse: false }); });
  } else {
    update({ pulse: false });
  }

  // Listen to Shopify-emitted cart events
  document.addEventListener('cart:refresh', function () { update({ pulse: true }); });
  document.addEventListener('cart:updated', function () { update({ pulse: true }); });

  // Catch all cart mutation requests (Dawn quick-add-bulk, persons stepper, ADD TO CART, etc.)
  // by wrapping fetch — when the response comes back, refresh the FAB.
  var origFetch = window.fetch;
  window.fetch = function (input, init) {
    var p = origFetch.apply(this, arguments);
    var url = typeof input === 'string' ? input : (input && input.url) || '';
    if (/\/cart\/(add|update|change|clear)/.test(url)) {
      p.then(function () { setTimeout(function () { update({ pulse: true }); }, 80); }).catch(function () {});
    }
    return p;
  };

  // Re-init on Shopify section refresh (theme editor / live edits)
  document.addEventListener('shopify:section:load', function () { update({ pulse: false }); });
})();
